export default __webpack_public_path__ + "static/media/IMG_5579.e02a477a.jpg";